import Headroom from 'headroom.js';
import { attribute } from 'postcss-selector-parser';

(function ($, root, undefined) {

  $(function () {

    'use strict';

    var header = document.getElementById("header");                              // The main header

    /* Handle the main header using headroom.js */
    if (header) {
      var options = {
        // vertical offset in px before element is first unpinned
        offset: 0,
        // or you can specify offset individually for up/down scroll
        offset: {
          up: 100,
          down: 100
        },
      };
      var headroom = new Headroom(header, options);
      headroom.init();
    }

    $(document).ready(function () {
      // Header stuff
      var header = $('#header');

      // Nav Toggle
      $('.mobile-menu-toggle').on('click', () => {
        $('html').toggleClass('menu-open');
        $(".nav-closed, .nav-open").toggleClass("nav-closed nav-open");
      });

      //Mobile sub-menu
      $('.mobile-navigation .menu-item > a').each(function (index) {
        var href = $(this).attr('href');
        if (href != null && href.includes('#toggle')) {
          $(this).on('click', (e) => {
            e.preventDefault();
            $('.mobile-navigation .menu-item > a').not(this).each(function (index) {
              $(this).removeClass('open');
            });
            $(this).toggleClass('open');
          });
        }
      });

      $('.desktop-utility-navigation .menu-item > a').each(function (index) {
        var href = $(this).attr('href');
        if (href != null && href.includes('#toggle')) {
          $(this).on('click', (e) => {
            e.preventDefault();
            $('.desktop-utility-navigation .menu-item > a').not(this).each(function (index) {
              $(this).removeClass('open');
            });
            $(this).toggleClass('open');
          });
        }

        $(document).on('click', (e) => {
          if ($('.desktop-utility-navigation').has(e.target).length === 0) {
            $('.desktop-utility-navigation .menu-item > a').each(function (index) {
              $(this).removeClass('open');
            });
          }
        });
      });

      // Main Nav Panel Toggle
      var openPanel = null;
      $('.desktop-navigation .menu-item > a').each(function (index) {
        var href = $(this).attr('href');
        if (href.includes('#')) {
          $(this).on('click', (e) => {
            e.preventDefault();
            $(this).toggleClass('text-yellow-500');
            $('.desktop-navigation .menu-item > a').not(this).each(function (index) {
              $(this).removeClass('text-yellow-500');
            });
            if (openPanel == href) {
              $(openPanel).hide();
              $('html').removeClass('mega-menu-panel-open');
              $('html').removeClass('overflow-hidden');
              openPanel = null;
              $('.desktop-navigation .menu-item > a').each(function (index) {
                $(this).removeClass('text-yellow-500');
              });
            } else {
              openPanel = href
              $('.mega-menu-panels .panel').each(function () {
                $(this).hide();
              });
              $(openPanel).show();

              $(openPanel + ' .close-modal').on('click', () => {
                $(openPanel).hide();
                openPanel = null;
                $('html').removeClass('mega-menu-panel-open');
                $('html').removeClass('overflow-hidden');
                $('.desktop-navigation .menu-item > a').each(function (index) {
                  $(this).removeClass('text-yellow-500');
                });
              })

              if (openPanel) {
                $('html').addClass('mega-menu-panel-open');
                $('html').addClass('overflow-hidden');
              } else {
                $('html').removeClass('mega-menu-panel-open');
                $('html').removeClass('overflow-hidden');
              }
            }

            $(document).on('click', (e) => {
              if (header.has(e.target).length === 0) {
                $(openPanel).hide();
                openPanel = null;
                $('html').removeClass('mega-menu-panel-open');
                $('html').removeClass('overflow-hidden');
                $('.desktop-navigation .menu-item > a').each(function (index) {
                  $(this).removeClass('text-yellow-500');
                });
              }
            });

          });
        }
      });
      // Search Toggle
      $('.search-form-toggle').on('click', () => {
        $('.search-form-container').toggleClass("open");
        $('.search-form-container .search-input').focus();
        $(document).on('click', (e) => {
          if (header.has(e.target).length === 0) {
            $('.search-form-container').removeClass('open');
          }
        });
      });

      //Sliders 
      if ($(".gallery-slider").length) {
        $(".gallery-slider").each(function () {
          var autoPlay = $(this).attr('data-auto-play');
          $(this).owlCarousel({
            loop: true,
            autoplay: autoPlay,
            margin: 0,
            nav: true,
            items: 1,
            autoHeight: true,
            navText: ['<i class="icon current-color"><svg><use xlink:href="#icon-arrow-left"></use></svg></i>', '<i class="icon current-color"><svg><use xlink:href="#icon-arrow"></use></svg></i>'],
          });
        });
      }

      Fancybox.bind('[data-fancybox="slider-gallery"]', {
        //dragToClose: false,
        Thumbs: false,

        Image: {
          zoom: false,
          click: false,
          wheel: "slide",
        },

        on: {
          // Move caption inside the slide
          reveal: (f, slide) => {
            slide.$caption && slide.$content.appendChild(slide.$caption);
          },
        },
      });

    });

  });


})(jQuery, this);
